import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AdCaller from 'helpers/ads/adCaller';
import s from './ExitPollWrapper.scss';
import ElectionStatusCard from '../../../components/ElectionV2/assembly/ElectionStatusCard/ElectionStatusCard';
import DataBarsWrapper from '../../../components/ElectionV2/common/DataBarsWrapper/DataBarsWrapper';
import DataBar from '../../../components/ElectionV2/common/DataBar/DataBar';

class ExitPollWrapper extends React.Component {
  renderElectionstate = () => {
    const {
      hideBattle,
      hideStarCandidate,
      hideLiveblog,
      isWapView,
      hideETheading,
      hideLink,
      wgtclient,
      states = [],
      isExitPoll,
      electionData,
      sortedData,
      sectionData,
    } = this.props;

    const { common = false } = sectionData.items;

    return (
      <>
        <AdCaller data={{ name: 'exit_first' }} immediateLoad />
        {common
          ? states &&
            states.length > 0 &&
            states.map(state => (
              <ElectionStatusCard
                key={state.name}
                isExitPoll={isExitPoll}
                config={state}
                data={electionData[state.key]}
                sortedData={sortedData && sortedData[state.key]}
                isWapView={isWapView}
                setAlliancePopUpData={this.setAlliancePopUpData}
                starCandidateData={false}
                hideStarCandidate={hideStarCandidate}
                hideLiveblog={hideLiveblog}
                hideETheading={hideETheading}
                hideLink={hideLink}
                numberOfStates={states.length}
                hideBattle={hideBattle}
                wgtclient={wgtclient}
                infoMsgClass={state.className}
                noMinHeight
              />
            ))
          : states &&
            Array.isArray(states) &&
            states.length === 1 &&
            states.map(
              state =>
                sortedData[state.key]?.finalSourceData &&
                Object.keys(sortedData[state.key]?.finalSourceData) &&
                Array.isArray(
                  Object.keys(sortedData[state.key]?.finalSourceData),
                ) &&
                Object.keys(sortedData[state.key]?.finalSourceData).length >
                  0 ? (
                  Object.keys(sortedData[state.key]?.finalSourceData).map(
                    source => (
                      <div className="boxStyle">
                        <div className={s.source}>
                          <span>Source:</span> {source}
                        </div>
                        <DataBarsWrapper
                          totalSeats={sortedData[state.key]?.activeSeats}
                          majority={sortedData[state.key]?.majority}
                          exitPoll={isExitPoll}
                          noMinHeight
                        >
                          {sortedData[state.key]?.finalSourceData[source] &&
                            sortedData[state.key]?.finalSourceData[source].map(
                              party => (
                                <DataBar
                                  color={party.color}
                                  name={party.an}
                                  ws={party.ls}
                                  wsc={party.wsc}
                                  ttl_seat={sortedData[state.key]?.activeSeats}
                                />
                              ),
                            )}
                        </DataBarsWrapper>
                      </div>
                    ),
                  )
                ) : (
                  <div className="noDataFound boxStyle">Exit Polls Awaited</div>
                ),
            )}
      </>
    );
  };

  render() {
    const { states = [] } = this.props;
    const { electionData } = this.props.sectionData.items;

    return (
      <div className={s.exitPollWidgetWrapper} ref={this.ref}>
        {electionData['2024'] &&
          electionData['2024'].note && (
            <p className={s.noteText}>{electionData['2024'].note}</p>
          )}
        {states && states.length > 0 && this.renderElectionstate()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.electionV2.refreshinterval,
  electionData: state?.electionV2.electionData,
  starCandidateData: state?.electionV2.starCandidateData,
  isExitPoll: state?.electionV2.isExitPoll,
  displaytext: state?.electionV2.displaytext,
  keywords: state?.electionV2.keywords,
  breakingnews: state?.electionV2.breakingnews,
  states: state?.electionV2.states,
  liveblog: state?.electionV2.liveblog,
  datasource: state?.electionV2.datasource,
  hideexitheading: state?.electionV2.hideexitheading,
  path: state?.electionV2.path,
  exitPollStateData: state?.electionV2.exitPollStateData,
  sortedData: state?.electionV2.sortedData,
});

ExitPollWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  isExitPoll: PropTypes.bool,
  hideETheading: PropTypes.bool,
};
ExitPollWrapper.defaultProps = {
  isWapView: false,
  data: {},
  isExitPoll: false,
  hideETheading: false,
};

export default connect(mapStateToProps)(ExitPollWrapper);
